/** @jsx jsx */
import { jsx } from '@emotion/core'
import { ExternalStyles, HFlow, Icon, Text } from 'bold-ui'
import { orange } from 'bold-ui/lib/styles/colors'

interface AlergiaPrincipioAtivoAlertProps {
  hSpacing?: number
  style?: ExternalStyles
}

export function AlergiaPrincipioAtivoAlert(props: Readonly<AlergiaPrincipioAtivoAlertProps>) {
  const { hSpacing = 0.25, style } = props

  return (
    <HFlow hSpacing={hSpacing} alignItems='center' style={style}>
      <Icon color={orange.c40} icon='exclamationTriangleOutline' size={1} />
      <Text color='alert'>Alergia ao princípio ativo</Text>
    </HFlow>
  )
}
